export default "__VITE_ASSET__1e4b5da4__"